import React from 'react';

import {useHref, useNavigate} from '../util/react-router-v6-shim';
import {AppTree} from './AppTree';

export const AppWithRoutes = () => {
  const navigate = useNavigate();

  return <AppTree navigate={navigate} useHref={useHref} />;
};
